export default __webpack_public_path__ + "f9dd244d45299a4054f427d54c65523d.png";